import React from "react";

import StatisticMain from "../../components/StatisticMain";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Finance = () => {

    const {t} = useTranslation();

    const [searchParams] = useSearchParams();

    const hash = window.location.hash;
    const hashWithoutHashSymbol = hash.slice(1);
    let isSurvey = 0
    let isReport = 0

    if (hashWithoutHashSymbol === 'survey')
        isSurvey = 1
    else if (hashWithoutHashSymbol === 'report')
        isReport = 1

    const arr = [1, 2, 3, 4, 5, 6, 7]

    const activeIndex = arr.indexOf(parseInt(searchParams.get("id")))

    return (
        <>
          <HelmetProvider>
            <Helmet>
                <title>{t('root.meta.finance.title')}</title>
                <meta property="description" content={t('root.meta.finance.description')}/>
                <meta property="og:site_name" content={t('root.meta.finance.title')}/>
                <meta property="og:title" content={t('root.meta.finance.title')}/>
                <meta property="og:description" content={t('root.meta.finance.description')}/>
            </Helmet>
          </HelmetProvider>
            <div className={"px-2 sm:px-0"}>
                <div className={"container mx-auto mt-4 mb-4 md:mt-6 md:mb-6"}>
                    <div className={"grid grid-cols-1 pt-4 pb-4"}>
                        <p className={"text-4xl text-[#163578] uppercase"}>{t('finance.mainTitle')}</p>
                    </div>
                </div>
                <StatisticMain mainParentId={10} isSurvey={isSurvey} isReport={isReport} activeIndex={activeIndex}/>
            </div>
        </>
    );
};

export default Finance;